import { combineReducers } from 'redux';

const getInitialState = () => {
  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : {};
  const { isClearTaxInvoice = '', isIrnNeeded = '', user_id: apobSupplierID = '' } = loginData;
  return { apobSupplierID, isClearTaxInvoice, isIrnNeeded };
};

const selectApobSeller = (state = getInitialState(), action) => {
  const { type, apobSupplierID, isClearTaxInvoice, isIrnNeeded } = action;
  switch (type) {
    case 'SET_SELECT_APOB_SELLER':
      return {
        ...state,
        apobSupplierID,
        isClearTaxInvoice,
        isIrnNeeded,
      };
    default: {
      return { ...state };
    }
  }
};

let combinedSelectApobSeller = combineReducers({
  selectApobSeller,
});
export default combinedSelectApobSeller;
